import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Globals} from '.././globals';
@Injectable()
export class TopicService {

  constructor(private http: HttpClient,private _global:Globals) { }
  readonly rootUrl = this._global.siteUrl;

  getTopicDetail(Obj){   
    
    var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'topic/detail', Obj,{ headers: reqHeader});  
   
  }
  
  saveTopic(Obj,topicid,mediaid){    
    let sendobj={};
    sendobj['data']=Obj;
    sendobj['id']=topicid;
    sendobj['mediaid']=mediaid;    
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/savetopic', sendobj,{ headers: reqHeader});   
  }

  saveFollower(Obj){    
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/saveFollower', Obj,{ headers: reqHeader});   
  }
  saveunFollower(Obj){    
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/saveunFollower', Obj,{ headers: reqHeader});   
  }

  topicbookmark(Obj){    
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/topicBookmark', Obj,{ headers: reqHeader});   
  }
  topicunbookmark(Obj){    
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/topicUnBookmark', Obj,{ headers: reqHeader});   
  }

  gettopiclist(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/gettopiclist', Obj,{ headers: reqHeader});
  }

  deletetopic(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'False'});
    return this.http.post(this.rootUrl + 'topic/deletetopic', Obj,{ headers: reqHeader});

  }

  getPopularTopic(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'topic/getPopularTopic', Obj,{ headers: reqHeader});

  }

  getTopic(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'topic/getTopic', Obj,{ headers: reqHeader});

  }

  getSearchResults(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'topic/getSearchResults', Obj,{ headers: reqHeader});
    
  }
  followTopic(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'topic/followTopic', Obj,{ headers: reqHeader});
    
  }

  getfollower(Obj){
    var reqHeader = new HttpHeaders({'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'topic/getfollower', Obj,{ headers: reqHeader});
    
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/topic.service.ts